import { render, staticRenderFns } from "./TypeRegister.vue?vue&type=template&id=ab3b380e"
import script from "./TypeRegister.vue?vue&type=script&lang=js"
export * from "./TypeRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab3b380e')) {
      api.createRecord('ab3b380e', component.options)
    } else {
      api.reload('ab3b380e', component.options)
    }
    module.hot.accept("./TypeRegister.vue?vue&type=template&id=ab3b380e", function () {
      api.rerender('ab3b380e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/occurrence/TypeRegister.vue"
export default component.exports